export default "__VITE_ASSET__VvxpZCvf__"